<div class="candidate-job-match-profile-container p-3" *ngIf="!displayFeedback">
    <div class="row">
        <div class="col-md-3">
            <select class="form-control" name="scheduleActions" id="scheduleActions"
                    [(ngModel)]="scheduleAction"
                    required>
                <option *ngFor="let action of scheduleActions; let i = index"
                    [value]="action" [title]="action">
                    {{action}}
                </option>
            </select>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-10">
            <schedule-job-match-item *ngIf="scheduleAction == 'Create'"
                [jobMatchObject]="jobMatchObject"
                [jobLocation]="jobMatchObject.jobLocation"
                [itemType]="itemType"
                mode="add"
                [jobMatchId]="jobMatchId"
                (saveCallback)="onScheduleCreated()"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </schedule-job-match-item>

            <schedule-job-match-item *ngIf="scheduleAction == 'Modify'"
                [jobMatchObject]="jobMatchObject"
                [jobLocation]="jobMatchObject.jobLocation"
                [itemType]="itemType"
                mode="edit"
                [jobMatchId]="jobMatchId"
                (saveCallback)="onScheduleModified()"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </schedule-job-match-item>

            <app-cancel-job-match-meeting *ngIf="scheduleAction == 'Cancel'"
                [jobMatchObject]="jobMatchObject"
                [itemType]="itemType"
                [isSharedRequisition]="isSharedRequisition"
                [jobMatchId]="jobMatchId"
                (saveCallback)="onScheduleCancelled()"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-cancel-job-match-meeting>
        </div>
    </div>
</div>

<!-- Display feedback -->
<div class="container" *ngIf="displayFeedback && !isLoading" style="position:relative">
    <tabset class="schedules-on-profile">
        <tab *ngFor="let tab of tabs; let $index = index" [heading]="tab.name"
            [active]="activeTab == $index" (select)="activeTab = $index">
            <div class="row" *ngIf="activeTab == $index && tab.name == 'Schedule'">
                <div class="col-md-12" *ngIf="allowInterviewSchedule">
                    <div class="col-md-3">
                        <select class="form-control" name="scheduleActions" id="scheduleActions"
                                [(ngModel)]="scheduleAction"
                                required>
                            <option *ngFor="let action of scheduleActions; let i = index"
                                [value]="action" [title]="action">
                                {{action}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12 mt-3" *ngIf="allowInterviewSchedule">
                    <div class="col-md-12">
                        <schedule-job-match-item *ngIf="scheduleAction == 'Create'"
                            [jobMatchObject]="jobMatchObject"
                            [jobLocation]="jobMatchObject.jobLocation"
                            [itemType]="itemType"
                            mode="add"
                            [jobMatchId]="jobMatchId"
                            (saveCallback)="onScheduleCreated()"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </schedule-job-match-item>

                        <schedule-job-match-item *ngIf="scheduleAction == 'Modify'"
                            [jobMatchObject]="jobMatchObject"
                            [jobLocation]="jobMatchObject.jobLocation"
                            [itemType]="itemType"
                            mode="edit"
                            [jobMatchId]="jobMatchId"
                            (saveCallback)="onScheduleModified()"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </schedule-job-match-item>

                        <app-cancel-job-match-meeting *ngIf="scheduleAction == 'Cancel'"
                            [jobMatchObject]="jobMatchObject"
                            [itemType]="itemType"
                            [isSharedRequisition]="isSharedRequisition"
                            [jobMatchId]="jobMatchId"
                            (saveCallback)="onScheduleCancelled()"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-cancel-job-match-meeting>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="!allowInterviewSchedule">
                    <div class="alert alert-info">
                        Please complete all phone screen feedbacks and move the candidate to Interview step before scheduling for Interview.
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="activeTab == $index && tab.name == 'Completed Feedback'">
                <div class="col-xs-12">
                    <object [attr.data]="tab.url + '#view=fitH'" type="application/pdf"
                        style="width:100%; height:500px;">
                        <embed [attr.src]="tab.url" type="application/pdf" width="100%" height="500px"/>
                    </object>
                </div>
            </div>
            <app-feedback-execution *ngIf="activeTab == $index && tab.name == 'Feedback'"
                [jobMatchId]="jobMatchId"
                [candidateId]="candidateId"
                [parentScheduleId]="scheduleId"
                (completeFeedbackCallback)="feedbackCompleteCallback()"
                (saveCallback)="feedbackSaveCallback()"
                [feedbackType]="feedbackType"
                [feedbackUserIdsList]="feedbackUserIdsList"
                [externalCommentRequired]="false"
                [loginRequired]="true"
                context="conference"
                [usersToEditFeedback]="usersToEditFeedback"
                [feedbackReadOnly]="feedbackReadOnly"
                [externalMeetingCallId]="externalMeetingCallId"
                (externalMeetingCallIdChange)="externalMeetingCallId = $event"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload"
                (formalizeActivityPayloadChange)="formalizeActivityPayload = $event">
            </app-feedback-execution>
            <div class="row" *ngIf="activeTab == $index && tab.isMoveForwardTab && !tab.disabled">
                <div class="col-md-12">
                    <app-move-job-match-step
                        [jobMatchId]="jobMatchId"
                        moveType="Forward"
                        [notifyUsers]="true"
                        [meetingScheduleId]="scheduleId"
                        [externalMeetingId]="externalMeetingCallId"
                        (saveCallback)="reloadAndMoveToInterviewCallback()"
                        [label]="tab.name"
                        [candidateId]="candidateId"
                        [sourceScreen]="sourceScreen"
                        [formalizeActivityPayload]="formalizeActivityPayload">
                    </app-move-job-match-step>
                </div>
            </div>
            <div class="row" *ngIf="activeTab == $index && tab.isMoveForwardTab && tab.disabled">
                <div class="col-md-12">
                    <div class="alert alert-warning">{{tab.message}}</div>
                </div>
            </div>
        </tab>
    </tabset>
</div>
